import React, { useState, useEffect } from 'react';
import './MainMenu.css';
import { QrReader } from 'react-qr-reader';
import { useNavigate } from 'react-router-dom';
import en from '../locales/eng.json';
import th from '../locales/th.json';
import CONFIG from '../config';
import PromotionSlider from './PromotionSlider';

import getProfileImage from '../utils/getProfileImage';

function MainMenu() {
  const storedData = localStorage.getItem('userData');
  const navigate = useNavigate(); 
  const [showScanner, setShowScanner] = useState(false);
const [qrResult, setQrResult] = useState(null);
const [userData, setUserData] = useState(null);
const [showMenu, setShowMenu] = useState(false);
const [earnedExpiry, setEarnedExpiry] = useState(null);

  const [language, setLanguage] = useState(() => {
  return localStorage.getItem('language') || 'TH';
});
const [t, setT] = useState(language === 'EN' ? en : th);

  const profileImage = getProfileImage()

useEffect(() => {
  const fetchUserData = async () => {
    try {
      const res = await fetch(`${CONFIG.API_BASE_URL}/lineuser/fetch_user_data?line_user_id=`+ localStorage.getItem('line_user_id'));
      const result = await res.json();

      if (result?.content?.data) {
        setUserData(result.content.data);
      } else {
        throw new Error("Invalid user data format");
      }
    } catch (e) {
      console.error("Failed to fetch user data:", e);
      navigate('/'); // Navigate away if error
    }
  };

  fetchUserData();
}, [navigate]);

useEffect(() => {
  localStorage.setItem('language', language); // Save to localStorage
  setT(language === 'EN' ? en : th);          // Set translation
}, [language]);

  useEffect(() => {
    const fetchPointHistory = async () => {
      try {
        const lineUserId = localStorage.getItem('line_user_id');
        if (!lineUserId) return;

        const res = await fetch(
          `${CONFIG.API_BASE_URL}/linepoint/history?line_user_id=${lineUserId}`,
          {
            headers: { accept: 'application/json' }
          }
        );
        const json = await res.json();
        const history = json?.content?.data || [];

        // Filter only entries where status === "Earned"
        const earnedEntries = history.filter((h) => h.status === 'Earned');
        if (earnedEntries.length === 0) {
          setEarnedExpiry(null);
          return;
        }

        // Find the oldest redeemed_at among those “Earned”
        let oldestDate = earnedEntries[0].redeemed_at;
        for (let entry of earnedEntries) {
          if (new Date(entry.redeemed_at) < new Date(oldestDate)) {
            oldestDate = entry.redeemed_at;
          }
        }

        // Compute expiry = oldestDate + 1 year
        const baseDate = new Date(oldestDate);
        const expiryDate = new Date(baseDate);
        expiryDate.setFullYear(expiryDate.getFullYear() + 1);

        setEarnedExpiry(expiryDate);
      } catch (err) {
        console.error('Failed to fetch point history:', err);
        setEarnedExpiry(null);
      }
    };

    fetchPointHistory();
  }, []);

  
  return (
    <div>
        <div className="top-section">
    {/* top bar */}
    <div className="top-bar">
      <img onClick={() => navigate('/')} src="/assets/logo-ujoy.png" alt="logo" className="logo-ujoy" />
      <div className="right-section">
        <div className="lang-selector">
          <button
  className={`lang-button ${language === 'TH' ? 'active' : ''}`}
  onClick={() => setLanguage('TH')}
>
  TH
</button>
|
<button
  className={`lang-button ${language === 'EN' ? 'active' : ''}`}
  onClick={() => setLanguage('EN')}
>
  EN
</button>

        </div>


        {showMenu ? 
          <div >
           
 {showMenu && (
  <>
   <img
  onClick={() => navigate('/profile')}
  src="/assets/mascot-full.png"
  alt="avatar"
  style={{ position: 'relative', zIndex: 9998 }} // ADD position
/>
    <div className="menu-overlay" onClick={() => setShowMenu(false)}></div>
    <div className="menu-popup-wrapper">
      <div className="menu-popup">
        <div className="menu-item" onClick={() => { navigate('/my-coupon'); setShowMenu(false); }}>
          <img src="/assets/icon-coupon.png" alt="coupon" />
          <span>คูปองของฉัน</span>
        </div>
        <div className="menu-item" onClick={() => { navigate('/point-redeem'); setShowMenu(false); }}>
          <img src="/assets/icon-redeem.png" alt="redeem" />
          <span>แลกคะแนน</span>
        </div>
        <hr className="dashed-line" />
        <div className="menu-item" onClick={() => { navigate('/point-history'); setShowMenu(false); }}>
          <img src="/assets/icon-points.png" alt="points" />
          <span>คะแนนสะสม</span>
        </div>
        <hr className="dashed-line" />
      </div>
    </div>
  </>
)}


  </div>
  : <div><img
  onClick={() => navigate('/profile')}
  src={
    userData?.line_image_url
      ? userData.line_image_url
      : "/assets/avartar.png"
  }
  alt="avatar"
  className="profile-avatar"
/></div>}


      </div>
    </div>

    {/* greeting and scan */}
    <div className="greeting-scan-section">
      <p className="greeting-text">
        <img src="/assets/smile.png" alt="smile" className="greeting-icon" />
        {t.mainmenu.hi}, {userData?.name || 'Guest'}
      </p>
      <button className="scan-button" onClick={() => setShowScanner(true)}>

        <img src="/assets/qr_code.png" alt="qr icon" className="qr-icon" />
        {t.mainmenu.scan}
      </button>
    </div>

  </div>
    <div className="main-menu-container">


      {/* cloud & member ID */}
      <div className="info-summary-section">
      <div className="cloud-wrapper">
        <img src="/assets/cloud.png" alt="cloud mascot" className="cloud-image" />
      </div>
      

      <div className="member-id-card">
        <br/>
        <p className="member-id-text">Member ID&nbsp;UF{userData?.phone || 'XXXXXXX'}</p>
      </div>
    </div>

  {/* Remaining UI (buttons, etc.) */}
  <div>
  <div
  className="points-image-container"
  onClick={() => navigate('/point-collect')}
>
  <img
    src="/assets/button_point.png"
    alt="point background"
    className="points-image-bg"
  />
  <div className="points-overlay">
    <p className="points-label">{t.mainmenu.points}</p>
    <div className="points-value-row">
      <span className="points-amount">
        {userData?.point?.toLocaleString() || '0'}
      </span>
      <img src="/assets/coin.png" alt="coin" className="coin-icon" />
    </div>
  </div>
</div>


<p className="point-expiry">{userData?.point?.toLocaleString()} {t.mainmenu.points_expiry} {earnedExpiry && (
            <>
               {earnedExpiry.toLocaleDateString('en-GB')}
            </>
          )}</p>

<div className="button-section">
  <button className="outlined-button" onClick={() => navigate('/point-redeem')}>
    <img src="/assets/rewarded_ads.png" alt="redeem" className="button-icon" />
    {t.mainmenu.redeem}
  </button>
  <button className="filled-button" onClick={() =>  navigate('/my-coupon')}>
    <img src="/assets/confirmation_number.png" alt="coupon" className="button-icon" />
    {t.mainmenu.my_coupons}
  </button>
</div>

<div className="promotion-wrapper">
  <h2 className="promotion-title">{t.mainmenu.promotion}</h2>
  <div className="promotion-banner">
    <PromotionSlider />
  </div>
</div>

  </div>

  {showScanner && (
  <div className="qr-scanner-overlay">
    <button className="qr-close-button" onClick={() => setShowScanner(false)}>✕</button>
    <QrReader
      constraints={{ facingMode: 'environment' }}
      onResult={(result, error) => {
        if (!!result) {
          setQrResult(result?.text);
          setShowScanner(false);
          window.location.href = result?.text;
        }
      }}
      containerStyle={{ width: '100%', height: '100%' }}
      videoStyle={{ width: '100%', height: '100%', objectFit: 'cover' }}
    />
  </div>
)}
</div>
</div>

  );
}

export default MainMenu;
